module.exports = __webpack_public_path__ + "media/01d.2016a0ba.mp4";